export default {"src":"/_next/static/media/movie_beginning.5dd9de04.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};